import AutomobileAsset from '../../asset/automobile-asset';
import Cta from '../../cta';
import AutomobileCta from '../../cta/automobile-cta';
import AssetWrapper from '../../asset/wrappers';
import { buildCtaRenderLocationElement, getAutomobileAssetData } from './utils';
import Asset from '../../asset/asset';
import { createStyleTag, StyleTag } from '../../util/create-style-tag';
import vdpStyleContent from './style/vdp.css';

/**
 * Holler Classic WordPress Vehicle Detail Page (VDP) Wrapper
 */
export class HollerWPVdpAssetWrapper extends AssetWrapper<AutomobileAsset> {
  getDocumentStyles(): StyleTag[] {
    return [createStyleTag(vdpStyleContent.toString(), 'vdp-style')];
  }

  getRenderLocation(): HTMLElement {
    const priceWrapperElement = this.container.querySelector('.dms-vdp__price-wrapper');
    if (!priceWrapperElement) {
      throw new Error('Price wrapper element is not loaded yet.');
    }
    const priceWrapperParentElement = priceWrapperElement.parentNode!;
    if (priceWrapperParentElement?.querySelector('.ol-target-element') !== null) {
      return priceWrapperParentElement.querySelector('.ol-target-element')!;
    }
    const ctaRenderLocation = buildCtaRenderLocationElement();
    priceWrapperElement.after(ctaRenderLocation);
    return ctaRenderLocation;
  }

  parseAssetData(): AutomobileAsset {
    return getAutomobileAssetData(this.container);
  }

  createCta(): Cta<Asset> {
    return new AutomobileCta(this, { style: 'standard' });
  }

  static getPageContainer(): HTMLElement {
    const selector = '.dms-vdp__main-container';
    const container = window.document.querySelector<HTMLElement>(selector);
    if (!container) throw new Error(`Page container not found: ${selector}`);
    return container;
  }

  static shouldWatchElements(): boolean {
    return true;
  }
}
